import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./request";
import { log } from "node:console";
import { IVendor } from "../models/vendor";

export function useGetAllNotifications(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['notifications', payload],
        async () => await api.get(`/api/v1/notifications`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return {
        notifications: items,
        total: meta.total_count,
        counts: meta.notification_counts || {},
        isFetching, refetch
    };
}

export function useGetNotificationCountsByCategory(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['notification_counts', payload],
        async () => await api.get(`/api/v1/notifications/group_count`, {
          ...payload,
          group: 'category'
        }),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    const counts = (data || {}).data
    return {
        counts: counts,
        isFetching, 
        refetch
    };
}

export function useUpdateNotificationStatus(payload: any, enabled = false) {
    const { data, isFetching, refetch } = useQuery(
        ['updateStatus', payload],
        async () => await api.put(`/api/v1/notifications/${payload.notification_id}`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    return { data: (data || {}).data, isFetching };
}
